import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IHeaderTable } from "../../../../types/global";

export const useSalesPaymentColumnDefs = (documentType: string) => {
  const { t } = useTranslation();
  const [columnDef, setColumnDef] = useState<IHeaderTable[]>([]);

  useEffect(() => {
    const defaultCol: IHeaderTable[] = [
      {
        thaiLabel: "วันที่",
        width: 88,
        align: "left",
      },
      {
        thaiLabel: t("sales.payment.payment_channel"),
        width: 168,
        align: "left",
      },
      {
        thaiLabel: t("sales.payment.payment_account"),
        width: 168,
        align: "left",
      },
      {
        thaiLabel: t("sales.payment.payment_amount"),
        width: 168,
        align: "right",
      },
      {
        thaiLabel: t("sales.payment.withholding_tax_amount"),
        width: 168,
        align: "right",
      },
      {
        thaiLabel: t("sales.payment.cheque_provider"),
        width: 168,
        align: "left",
      },
      {
        thaiLabel: t("sales.payment.cheque_no"),
        width: 168,
        align: "left",
      },
      {
        thaiLabel: t("sales.payment.cheque_date"),
        width: 88,
        align: "left",
      },
      {
        thaiLabel: t("sentence.remark"),
        width: 350,
        align: "left",
      },
    ];
    if (documentType === "sales_invoice") {
      setColumnDef([
        ...defaultCol,
        {
          thaiLabel: "",
          width: 36,
        },
      ]);
    } else {
      setColumnDef(defaultCol);
    }
  }, [documentType, t]);
  return columnDef;
};
